<form [formGroup]="form"
      *ngIf="!readOnly || 0 === invalidFields.length; else errorTemplate">
    <mat-form-field>
        <input matInput formControlName="threshold" [placeholder]="'THRESHOLD' | translate">
        <mat-error *ngIf="form.get('threshold')?.hasError('required')">{{'VALUE_FORM_REQUIRED' | translate}}</mat-error>
        <mat-error *ngIf="form.get('threshold')?.hasError('not a number')">{{'NUMBER_REQUIRED' | translate}}</mat-error>
    </mat-form-field>
    <mat-form-field>
        <input matInput formControlName="period" [placeholder]="'PERIOD_HOUR' | translate">
        <mat-error *ngIf="form.get('period')?.hasError('required')">{{'VALUE_FORM_REQUIRED' | translate}}</mat-error>
        <mat-error *ngIf="form.get('period')?.hasError('not a number')">{{'NUMBER_REQUIRED' | translate}}</mat-error>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{'TYPE' | translate}}</mat-label>
        <mat-select formControlName="type">
            <mat-option *ngFor="let option of typeOptions" [value]="option"> {{option}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('type')?.hasError('required')">{{'VALUE_FORM_REQUIRED' | translate}}</mat-error>
    </mat-form-field>
    <mat-form-field>
        <input matInput formControlName="hysteresis" [placeholder]="'HYSTERESIS' | translate">
        <mat-error
                *ngIf="form.get('hysteresis')?.hasError('required')">{{'VALUE_FORM_REQUIRED' | translate}}</mat-error>
        <mat-error
                *ngIf="form.get('hysteresis')?.hasError('not a number')">{{'NUMBER_REQUIRED' | translate}}</mat-error>
    </mat-form-field>

  <mat-form-field>
    <mat-select [placeholder]="'CHANNEL' | translate" formControlName="channel" [value]="form.get('channel')"
                [disabled]="readOnly">
      <mat-option [value]="0">{{'DEFAULT-CHANNEL' | translate}}</mat-option>
      <mat-option [value]="1">{{ 'CHANNEL-B' | translate}}</mat-option>
    </mat-select>
  </mat-form-field>
</form>


<ng-template #errorTemplate>
    <div class="sub-section">
        <app-invalid-value-error-message message="INVALID_VALUES">
        </app-invalid-value-error-message>
    </div>
</ng-template>
